import { useEffect, useRef } from 'react';

// Components
import Container from '@components/container';
import Iframe from '@widgets/iframe';

const GetBrowserData = () => {
  const hiddenFormRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (hiddenFormRef.current) {
        hiddenFormRef.current.submit();
      }
    }, 0);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  const iframeId = 'browser-iframe';
  const id = 'SaveBrowserData';

  return (
    <Container hidden>
      <form ref={hiddenFormRef} action="/bff/v1/browser-data" id={id} method="GET" name={id} target={iframeId} />
      <Iframe id={iframeId} name={iframeId} />
    </Container>
  );
};

export default GetBrowserData;
